module.exports = __webpack_public_path__ + "static/media/Reitti-thumbnail.01b74e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Reitti-thumbnail.png
// module id = 1434
// module chunks = 0